import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from '@/plugins/axios'
import VueAxios from 'vue-axios'

import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify'

Vue.use(VueAxios, axios)

Vue.config.productionTip = false
Vue.use(Vuetify)

new Vue({
  router,
  store,
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount('#app')
